export enum Filter {
  ALL = 'all',
  INVITED = 'invited',
  ACTIVE_ALL = 'all_active',
  ACTIVE_UNASSIGNED = 'active_unassigned',
  ACTIVE_ASSIGNED = 'active_assigned',
}

export type SeatAvailability = Record<string, { taken: number; free: number; total: number }>;
export type ScimStatus = { active: boolean; idpName: string | null };
export type UserLicenseAssignments = {
  subscriptions: string[];
};
export type LicenseAssignmentsByUser = Record<string, UserLicenseAssignments>;
